import { zSchema, schemes } from "../schema-validation";

export const CustomerAccountContactSchema = zSchema.object({
  contact_id: schemes.uuid(),
  email: schemes.email().optional(),
  first_name: zSchema.string(),
  last_name: zSchema.string().optional(),
  phone: zSchema.string().optional(),
  priority: zSchema.enum(["primary", "secondary", "none"]).default("none"),
});

export type CustomerAccountContact = zSchema.infer<
  typeof CustomerAccountContactSchema
>;

export type CreateCustomerAccountContact = Omit<
  CustomerAccountContact,
  "contact_id"
>;

export const createCustomerAccountContactApiSchema = zSchema.object({
  companyID: schemes.uuid(),
  customer_account_id: schemes.uuid(),
  contact: CustomerAccountContactSchema.pick({
    email: true,
    first_name: true,
    last_name: true,
    phone: true,
    priority: true,
  }),
});
